<button
    class="widget-footer btn d-flex align-items-center w-100 border-radius-0 d-flex flex-row justify-content-between"
>
    <ng-content></ng-content>
    <i class="ms-2 fal fa-chevron-right"></i>
</button>
